export default [
    {
        path: '/admin/setup-news',
        name: 'setup-news',
        meta: { requiresAuth: true },
        component: () => import('@/pages/website/setup-news/index.vue')
    },
    {
        path: '/admin/setup-news/create',
        name: 'create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/website/setup-news/create.vue')
    },
    {
        path: '/admin/setup-news/:id',
        name: 'news-edit',
        meta: { requiresAuth: true },
        component: () => import('@/pages/website/setup-news/edit.vue'),
    }
]
